declare global {
  interface Window {
    dataLayer?: Record<string, any>[];   // <-- change only this line
  }
}

interface GTMEventProps { [key: string]: any; }

export const addGTMEvent = (eventName: string, props: GTMEventProps = {}): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...props });
};